import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Alert,
  Box
} from '@mui/material';

const IOSTroubleshootingDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        📱 iOS Camera Troubleshooting Guide
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          iOS Safari has known limitations with camera access in web apps. Here are several solutions:
        </Alert>

        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Why iOS Safari doesn't always show camera options:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText 
              primary="Security Restrictions"
              secondary="iOS Safari restricts camera access for security reasons"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Inconsistent Implementation"
              secondary="Different iOS versions handle the 'capture' attribute differently"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Browser Limitations"
              secondary="Safari has more restrictions than Chrome or Firefox"
            />
          </ListItem>
        </List>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Solutions (try in order):
        </Typography>
        <List>
          <ListItem>
            <ListItemText 
              primary="1. Try Different Camera Buttons"
              secondary="Each button uses different capture methods - one might work where others don't"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="2. Grant Camera Permissions"
              secondary="Safari > Settings > Camera > Allow - then refresh the page"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="3. Use Alternative Browser"
              secondary="Download Chrome or Firefox for iOS - they often have better camera support"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="4. Take Photo First, Then Upload"
              secondary="Use your Camera app to take a photo, then use 'Choose from Photo Library'"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="5. Add to Home Screen"
              secondary="Safari > Share > Add to Home Screen - sometimes PWA mode works better"
            />
          </ListItem>
        </List>

        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>Known iOS Versions with Issues:</strong>
            <br />
            • iOS 15.x - Intermittent camera access
            <br />
            • iOS 16.0-16.2 - Limited capture attribute support
            <br />
            • iOS 17.x - Improved but still inconsistent
          </Typography>
        </Alert>

        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Technical Note:</strong> This is a limitation of iOS Safari, not our app. 
            Apple restricts camera access in web browsers for security reasons. 
            Native apps don't have this limitation.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IOSTroubleshootingDialog;
